export default __webpack_public_path__ + "locales/ru/FormFillingTipsDialog.json?hash=05a39f9935f0c7800693187b52d4dd5f";